import React, { useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  FilterButton,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useGetList,
  useList,
  ListContextProvider,
  Pagination,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

// 筛选器组件
const UserListFilters = [
  <TextInput source="name" label="姓名" alwaysOn />,
  <TextInput source="phone" label="手机号" alwaysOn />,
  <TextInput source="email" label="邮箱" alwaysOn />,
];

// 工具栏组件
const ListActions = () => (
  <TopToolbar>
    <FilterButton filters={UserListFilters} />
    <ExportButton />
    <CreateButton />
  </TopToolbar>
);

// 用户列表组件
export const UserList: React.FC = (props: any) => {
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);

  // 使用 useGetList 获取分页数据
  const { data, total, isLoading } = useGetList('users', {
    pagination: { page, perPage },
    sort: { field: 'id', order: 'DESC' },
  });

  // 创建列表上下文
  const listContext = useList({ data, isLoading, perPage, page });

  return (
    <List
      {...props}
      actions={<ListActions />}
      filters={UserListFilters}
      pagination={<Pagination />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        {<FunctionField
          label="姓名"
          render={(record: any) =>
            `${record.lastName || ''} ${record.name || ''}`
          }
        />
        /* <TextField source="username" label="用户名" /> */}
        <TextField source="phone" label="手机号" />
        <EmailField source="email" label="邮箱" />
        <FunctionField
          label="身份"
          render={(record: any) => {
            const isOwner = record.role === 1;

            return (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  px: 1,
                  py: 0.25,
                  borderRadius: 1,
                  fontWeight: 600,
                  color: isOwner ? 'black' : 'text.primary',
                  backgroundColor: isOwner ? 'warning.light' : 'transparent',
                }}
              >
                {isOwner ? '货主' : '司机'}
              </Box>
            );
          }}
        />
        {<FunctionField
          label="已认证"
          render={(record: any) => (record.verified ? "是" : "否")}
        />
        /* <FunctionField
          label="启用状态"
          render={(record: any) => (record.enabled ? "启用" : "禁用")}
        /> */}
      </Datagrid>
    </List>
  );
};

// 导出用户列表组件
export default UserList;